// import _ from 'lodash'

export const ensureNull = (value) => value || null
